import $ from "jquery"
import { PersonModel, PlaylistItemModel, Index } from "../model"
import htmlTemplate from "./osdTemplate.html"

type ClickCallback = () => void

type Properties = {
    container:JQuery,
    personIndex:Index<PersonModel>
}

type DisplayDetails = PlaylistItemModel

export default class OSD {

    private container:JQuery
    private personIndex: Index<PersonModel>

    private osd:JQuery
    private mainDisplay:JQuery
    private prevDisplay:JQuery
    private nextDisplay:JQuery

    constructor(properties:Properties) {
        this.container = properties.container
        this.personIndex = properties.personIndex

        this.osd = $(htmlTemplate)
        this.container.append(this.osd)

        this.mainDisplay = this.osd.find(".display-current")
        this.prevDisplay = this.osd.find(".display-prev")
        this.nextDisplay = this.osd.find(".display-next")
    }

    public updateOSD(main:DisplayDetails, prev:DisplayDetails, next:DisplayDetails) {
        this.updateMain(main)
        this.updateNext(next)
        this.updatePrev(prev)
    }
    
    public onPrevClicked(callback:ClickCallback) {
        this.prevDisplay.on("click", callback)
    }
    
    public onNextClicked(callback:ClickCallback) {
        this.nextDisplay.on("click", callback)
    }
    
    private updateMain(details:DisplayDetails|null) {
        this.updateOSDDisplay(details, this.mainDisplay)
    }
    
    private updateNext(details:DisplayDetails|null) {
        this.updateOSDDisplay(details, this.nextDisplay)
    }

    private updatePrev(details:DisplayDetails|null) {
        this.updateOSDDisplay(details, this.prevDisplay)
    }

    private updateOSDDisplay(details:DisplayDetails, display:JQuery) {
        if(!details) {
            display.hide()
        } else {
            const personModel = this.personIndex.get(details.personId)

            display.show()
            display.find(".person-content").text(personModel.name)
            display.find(".item-content").text(details.name)
        }
    }
}